import { render, staticRenderFns } from "./ModalTuinuiCard.vue?vue&type=template&id=504db5cd&scoped=true&"
import script from "./ModalTuinuiCard.vue?vue&type=script&lang=js&"
export * from "./ModalTuinuiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504db5cd",
  null
  
)

export default component.exports